import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { resetStateBetweenCallObjects } from '../app/actions';
import { fetchCallObject, getCallObjectById } from './actions';
const initialState = {
  isLoading: false,
  callObjectId: 0,
  callObjectTitle: ''
};
const callObject = createSlice({
  name: 'callObject',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(resetStateBetweenCallObjects.type, state => {
      state.callObjectId = 0;
      state.callObjectTitle = '';
    });
    builder.addMatcher(isAnyOf(fetchCallObject.fulfilled, getCallObjectById.fulfilled), (state, action) => {
      state.isLoading = false;
      state.callObjectId = action.payload.objectId;
      state.callObjectTitle = action.payload.properties.hs_call_title.value;
    });
    builder.addMatcher(isAnyOf(fetchCallObject.pending, getCallObjectById.pending), state => {
      state.isLoading = true;
    });
    builder.addMatcher(isAnyOf(fetchCallObject.rejected, getCallObjectById.rejected), state => {
      state.isLoading = false;
      state.callObjectId = 0;
      state.callObjectTitle = '';
    });
  }
});
export const callObjectActions = callObject.actions;
export default callObject.reducer;